var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "var(--gray-40)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1303 0.92749H11.9696L7.93099 5.52596L12.6494 11.7639H8.94665L6.04761 7.97314L2.72872 11.7639H0.889334L5.16791 6.84552L0.649414 0.92749H4.44415L7.06328 4.39034L10.1303 0.92749ZM9.48647 10.6842H10.5061L3.90833 1.96714H2.81269L9.48647 10.6842Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.96dce51467282b6ffe69bc9c80bfa902.svg";
export { ForwardRef as ReactComponent };